import {Group, Stack, ThemeIcon, Text, Title, Transition} from "@mantine/core";
import * as Sentry from "@sentry/react";
import {QuickSearchResult} from "../../../types";
import classes from "./RecentSearches.module.css";
import {useTranslation} from "react-i18next";
import IconArrowUpRight from "../../../assets/arrow-up-right.svg?react";
import IconHistory from "../../../assets/history.svg?react";
import {ExperimentalLink} from "../../../components/ExperimentalLink";

const MAX_ITEMS = 3;

export const RecentSearches = ({data}: {data: QuickSearchResult[]}) => {
    const {t} = useTranslation();
    return (
        <Stack gap={12} className={classes.recentSearchesList}>
            <Group gap="xs" wrap="nowrap">
                <ThemeIcon variant="subtle" size="sm" color="black">
                    <IconHistory width={24} />
                </ThemeIcon>
                <Title size="lg" fw={500}>
                    {t("common.recentSearches")}
                </Title>
            </Group>
            <Stack gap={0}>
                {data.slice(0, MAX_ITEMS).map((result, index) => (
                    <RecentSearchItem key={index} result={result} />
                ))}
            </Stack>
        </Stack>
    );
};

interface RecentSearchItemProps {
    result: QuickSearchResult;
}

const RecentSearchItem = ({result}: RecentSearchItemProps) => {
    return (
        <ExperimentalLink
            href={result.url}
            className={classes.recentSearchLink}
            onClick={() =>
                Sentry.metrics.count("chat.frontpage_recent_search_clicked")
            }
        >
            <Group
                gap="xs"
                wrap="nowrap"
                className={classes.recentSearchItem}
                justify="space-between"
                style={{width: "100%"}}
            >
                <Group gap="xs" wrap="nowrap">
                    <Text size="sm">{result.topictitle}</Text>
                </Group>
                <Group gap={3} wrap="nowrap" align="center">
                    <ThemeIcon variant="subtle" size="sm" color="gneis.8">
                        <IconArrowUpRight
                            className={classes.recentSearchChevron}
                            width={16}
                        />
                    </ThemeIcon>
                </Group>
            </Group>
        </ExperimentalLink>
    );
};
